import { useEffect, useRef, useState } from "react";


export default function WebChess() {
  const loadedRef = useRef(false);

  useEffect(() => {
    if (loadedRef.current) return;
    loadedRef.current = true;

    const loadSketch = () => {
      if (!document.getElementById("sketch-script")) {
        const sketchScript = document.createElement("script");
        sketchScript.src = "/p5js/Chess/sketch.js";
        sketchScript.id = "sketch-script";
        sketchScript.async = true;
        document.body.appendChild(sketchScript);
      }
    };

    if (!window.p5) {
      const p5Script = document.createElement("script");
      p5Script.src = "https://cdn.jsdelivr.net/npm/p5@1.2.0/lib/p5.min.js";
      p5Script.async = true;
      p5Script.onload = loadSketch; // Load sketch only after p5 is ready
      document.body.appendChild(p5Script);
    } else {
      loadSketch();
    }

    // Cleanup: optional, can be expanded
    return () => {
      const canvas = document.querySelector("canvas");
      if (canvas) canvas.remove();
    };
  }, []);

/*
export default function WebChess() {
    const loadedRef = useRef(false);
  const containerRef = useRef(null);
  const [p5Loaded, setP5Loaded] = useState(false);

  useEffect(() => {
    // Check if p5.js is already loaded
    if (!window.p5) {
      const scriptP5 = document.createElement("script");
      scriptP5.src = "https://cdn.jsdelivr.net/npm/p5@1.2.0/lib/p5.js";
      scriptP5.async = true;
      scriptP5.onload = () => setP5Loaded(true); // Mark p5 as loaded
      document.body.appendChild(scriptP5);
    } else {
      setP5Loaded(true); // If p5.js is already there, mark as loaded
    }
  }, []);

  useEffect(() => {
    if (p5Loaded) {
      // Load your sketch.js script only after p5.js is available
      const scriptSketch = document.createElement("script");
      scriptSketch.src = "/p5js/Chess/sketch.js"; // Path from public folder
      scriptSketch.async = true;
      document.body.appendChild(scriptSketch);

      return () => {
        document.body.removeChild(scriptSketch); // Cleanup
      };
    }
  }, [p5Loaded]); // Runs only when p5.js is loaded
*/
  return (
    <div style={{height: "100%", textAlign: "center"}}>
      <h3>WebChess</h3>
      <p style={{fontSize: "0.8em"}}>
        Classic game recreated with{" "}
        <a href="https://p5js.org/" target="_blank" rel="noopener noreferrer">
          P5JS
        </a>
        . Has en passant, pawn promotion, castling—everything you need to play
        chess. Have fun!
      </p>
      <div id="sketchContainer" style={{height: "28vw", width: "28vw", margin:"auto"}} ></div> {/* P5 will mount here */}
    </div>
  );
}
